import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import type { Timezone } from '@/config/tenants/types'

dayjs.extend(utc)
dayjs.extend(timezone)

export type DateInput = Date | string | number

//TODO: Change to take this from tenant settings
export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY'

export const DEFAULT_TODAY_DATE = dayjs()
export const DEFAULT_PAST_DATE_10_YEAR = dayjs().subtract(10, 'year')

function toDate(input: DateInput): Date {
  if (input instanceof Date) {
    return input
  }

  return new Date(input)
}

export function formatDate(input: DateInput, tz?: Timezone, locale?: string, dateFormat?: string): string {
  const date = dayjs(toDate(input)).tz(tz)

  return (locale ? date.locale(locale) : date).format(dateFormat || DEFAULT_DATE_FORMAT)
}

export function formatTime(input: DateInput, timezone: Timezone, locale: string): string {
  const formatter = new Intl.DateTimeFormat(locale, {
    timeZone: timezone,
    timeStyle: 'short',
  })

  return formatter.format(toDate(input))
}

export function formatDateTime(input: DateInput, timezone: Timezone, locale: string): string {
  const formatter = new Intl.DateTimeFormat(locale, {
    timeZone: timezone,
    dateStyle: 'medium',
    timeStyle: 'short',
  })

  return formatter.format(toDate(input))
}

export function formatDateCustom(
  input: DateInput,
  timezone: Timezone,
  locale: string,
  options: Intl.DateTimeFormatOptions
): string {
  const formatter = new Intl.DateTimeFormat(locale, {
    timeZone: timezone,
    ...options,
  })

  return formatter.format(toDate(input))
}
